import { UnderlinedTextButton } from "@/components/button/underlined-text-button";
import { PlanPageContainer } from "@/components/container/plan-page-container";
import { useIonRouter } from "@ionic/react";
import { PlanPreview } from "./plan-preview";

export default function PlanMainScreen() {
  const navigation = useIonRouter();

  const navigateToMyPlan = () => {
    navigation.push("/plans/my-plan", "none");
  };

  // const navigateToAskNutriCoach = () => {
  //   navigation.push("/chat");
  // };

  return (
    <PlanPageContainer className="app-bar-bottom-padding overflow-y-auto no-scrollbar">
      <div className="flex flex-col gap-6 w-full px-4">
        <div className="flex justify-between items-end">
          <h5 className="text-2xl font-semibold text-black">Today's Food</h5>
          <UnderlinedTextButton onClick={navigateToMyPlan}>
            View Plan
          </UnderlinedTextButton>
        </div>

        <PlanPreview />

        {/* <DailyCaloriesCard /> */}

        {/* <RecreatePlanButton /> */}

        {/* <button
          className="bg-white rounded-full py-4 border border-black flex items-center justify-center gap-2"
          onClick={navigateToAskNutriCoach}
        >
          <IonIcon icon={chatbubbleOutline} className="w-6 h-6" />
          Ask NutriCoach
        </button> */}
      </div>
    </PlanPageContainer>
  );
}
